<template>
  <v-container>
    <v-row align="center">
      <v-col cols="auto">
        <div class="title text-uppercase font-weight-medium">
          Browse Projects
        </div>
      </v-col>
      <v-spacer />
      <v-col cols="auto">
        <v-text-field
          v-model="filters.name"
          solo
          placeholder="Search"
          flat
          dense
          hide-details
          clearable
          append-icon="fas fa-search"
        />
      </v-col>
      <v-col cols="auto">
        <v-btn
          dark
          color="primary"
          class="ma-0"
          :to="{ name: 'new-project' }"
        >
          <v-icon
            left
            small
          >
            fas fa-plus
          </v-icon>
          Add New
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <pagination
          :page.sync="items.pagination.page"
          :last-page="items.meta.last_page"
          :total="items.meta.total"
          :from="items.meta.from"
          :to="items.meta.to"
        />
        <v-data-table
          :headers="headers"
          :items="items.data"
          :server-items-length="items.meta.total"
          :sort-by.sync="items.sorting.sortBy"
          :sort-desc.sync="items.sorting.desc"
          :page.sync="items.pagination.page"
          :items-per-page="items.pagination.perPage"
          :loading="items.loading"
          hide-default-footer
          must-sort
          class="v-data-table--striped elevation-15"
          @update:sort-by="fetchItems()"
          @update:page="fetchItems()"
        >
          <template v-slot:item="{ item: project }">
            <tr>
              <td>
                <router-link :to="{ name: 'project', params: { id: project.id }}">
                  <div class="subtitle-2 primary--text">
                    {{ project.title }}
                  </div>
                  <div class="caption text--secondary">
                    {{ project.excerpt }}
                  </div>
                </router-link>
              </td>
              <td
                style="width: 1px;"
                class="text-no-wrap"
              >
                {{ project.sort_order }}
              </td>
              <td style="width: 1px;">
                <span
                  v-if="project.updated_at"
                  class="text-no-wrap"
                >{{ $dayjs(project.updated_at).format('DD.MM.YYYY. HH:mm:ss') }}</span>
                <span
                  v-else
                  class="grey--text text--lighten-1"
                >Never</span>
              </td>
              <td
                class="text-no-wrap"
                style="width: 1px"
              >
                <v-menu
                  offset-y
                  min-width="140px"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      color="grey"
                      small
                      v-on="on"
                    >
                      <v-icon small>
                        fa fa-ellipsis-v
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list
                    dense
                    class="body-2"
                  >
                    <v-list-item :to="{ name: 'project', params: { id: project.id }}">
                      <v-list-item-icon>
                        <v-icon small>
                          fa fa-pen
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>Edit project</v-list-item-content>
                    </v-list-item>
                    <v-divider />
                    <v-list-item @click="deleteDialog.project = project; deleteDialog.visible = true">
                      <v-list-item-icon>
                        <v-icon small>
                          fa fa-trash
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>Delete project</v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="pa-2">
          <pagination
            :page.sync="items.pagination.page"
            :last-page="items.meta.last_page"
            :total="items.meta.total"
            :from="items.meta.from"
            :to="items.meta.to"
          />
        </div>
      </v-col>
    </v-row>

    <confirm-delete-dialog
      :visible.sync="deleteDialog.visible"
      :deleting="deleteDialog.deleting"
      @confirm="deleteProject()"
    />
  </v-container>
</template>

<script>
import fetchableItemsMixin from '@/mixins/fetchableItemsMixin'
import ConfirmDeleteDialog from '@/components/helpers/ConfirmDeleteDialog'
import Projects from '@/services/Projects'

export default {
  name: 'Projects',
  components: {
    ConfirmDeleteDialog
  },
  mixins: [fetchableItemsMixin],
  data() {
    return {
      deleteDialog: {
        project: undefined,
        visible: false,
        deleting: false
      }
    }
  },
  beforeCreate() {
    this.emptyFilters = { name: null }
  },
  created() {
    this.headers = [
      { text: 'Title', value: 'title' },
      { text: 'Order', value: 'sort_order' },
      { text: 'Last Update', value: 'updated_at' },
      { sortable: false }
    ]
  },
  methods: {
    async itemsFetcher(queryParams) {
      return await Projects.fetch(queryParams)
    },
    async deleteProject() {
      if (!this.deleteDialog.project) return

      this.deleteDialog.deleting = true

      try {
        await Projects.delete(this.deleteDialog.project.id)

        this.$store.dispatch('alert', {
          text: 'Successfully deleted',
          color: 'success'
        })

        this.fetchItems()
      } catch (e) {
        this.$store.dispatch('alert', {
          text: 'Something went wrong',
          color: 'error'
        })
        throw e
      } finally {
        this.deleteDialog.visible = false
        this.deleteDialog.deleting = false
      }
    }
  }
}
</script>
